import styled from 'styled-components';

export const LogoContainer = styled.div`
  padding: 15px 0;
`;
